var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagesBubbleAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_804_54920)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7694 16.625C36.5943 14.1066 35.848 11.6611 34.5871 9.47405C33.3262 7.28701 31.5837 5.41585 29.4919 4.0025C27.4001 2.58916 25.014 1.67075 22.5144 1.31694C20.0148 0.96314 17.4674 1.18323 15.0656 1.96052C12.6637 2.73781 10.4704 4.05189 8.65206 5.80307C6.83369 7.55425 5.43801 9.69655 4.57088 12.0675C3.70376 14.4384 3.38797 16.9756 3.64746 19.4867C3.90696 21.9979 4.73492 24.4169 6.06855 26.5604L1.18555 36.8125L11.4376 31.9295C12.3292 32.4828 13.2707 32.9514 14.2496 33.3292",
    stroke: "currentColor",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3125 36.8109C32.5592 36.8109 36.8125 32.5576 36.8125 27.3109C36.8125 22.0642 32.5592 17.8109 27.3125 17.8109C22.0658 17.8109 17.8125 22.0642 17.8125 27.3109C17.8125 32.5576 22.0658 36.8109 27.3125 36.8109Z",
    stroke: "currentColor",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3125 22.5609V32.0609",
    stroke: "currentColor",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5625 27.3109H32.0625",
    stroke: "currentColor",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesBubbleAdd);
export default __webpack_public_path__ + "static/media/messages-bubble-add.06d477a2097da11dd6871fb77e0e814d.svg";
export { ForwardRef as ReactComponent };